import React from 'react';
import { AlertTriangle, Briefcase, CalendarClock, Euro } from '../../../../shared/assets/AppIcons';
import DealsStatsGrid from '@/modules/deals/components/shared/DealsStatsGrid';

const IN_PROGRESS_STATS_CONFIG = [
  {
    key: 'total',
    title: 'Totale',
    tone: 'neutral',
    icon: Briefcase,
    cardClass: 'border-[var(--border)] bg-gradient-to-br from-[var(--success)] to-[var(--chart-accent-2)]',
    iconWrapClass: 'bg-[var(--success-soft)]',
    iconClass: 'text-[var(--success-text)]',
    titleClass: 'text-[var(--success-text)]',
    valueClass: 'text-[var(--success-text)]',
    description: () => 'pratiche operative visibili',
  },
  {
    key: 'estimatedVolume',
    title: 'Volume stimato',
    tone: 'neutral',
    icon: Euro,
    format: 'currency',
  },
  {
    key: 'highPriority',
    title: 'Alta priorità',
    tone: 'attention',
    icon: AlertTriangle,
  },
  {
    key: 'overdue',
    title: 'Scadute',
    tone: 'attention',
    icon: CalendarClock,
  },
];

const InProgressStats = ({ stats, activeMetric, onMetricClick }) => (
  <DealsStatsGrid
    items={IN_PROGRESS_STATS_CONFIG}
    stats={stats}
    activeMetric={activeMetric}
    onMetricClick={onMetricClick}
  />
);

export default InProgressStats;
